module.exports = __webpack_public_path__ + "media/83.a4d619b4.mp3";